<template lang="pug">
v-card(outlined).pa-4
  .d-flex.mb-4
    p.title.mb-0.mr-auto Уведомления
    v-btn.mr-2(@click="dialogCreate = true" color="success") Создать

  v-skeleton-loader(v-if="loading" type="card")

  template(v-else-if="notifications.length")
    v-alert(
      v-for="notification in notifications"
      type="success"
      :key="notification.id"
      text
    ) {{ notification.text }}
      template(#close)
        v-btn(
          color="error"
          @click="deleteNotification(notification.id)"
          outlined
          icon
          small
        )
          v-icon(small) mdi-close
    v-pagination(
      v-if="pagination.pages > 1"
      color="info"
      v-model="pagination.page"
      :length="pagination.pages"
      :total-visible="7"
    )
  v-alert(v-else type="info" text).mb-0 Уведомления не найдены

  v-dialog(v-model="dialogCreate" width="400px")
    v-card(dark flat).pa-4
      p.title Создание уведомления
      v-textarea(
        v-model="form.text"
        rows="3"
        filled
        label="Сообщение уведомления"
      )
      select-users(
        v-model="form.user_ids"
        filled
      )

      v-btn(
        @click="createNotification"
        color="success"
        :disabled="!form.text || !form.user_ids.length"
      ).mr-2 Отправить

      v-btn(@click="dialogCreate = false" text) Отменить
</template>

<script>
import adminNotificationService from '@/services/API/admin-notifications';
import { getPagination } from '@/lib/pagination';
import SelectUsers from '@/components/inputs/SelectUsers.vue';

const DEFAULT_FORM = {
  'text': '',
  'user_ids': [],
};

export default {
  components:{
    SelectUsers,
  },
  data() {
    return {
      notifications:[],

      loading:true,

      pagination: {
        page: 1,
        pages:1,
      },

      form :{ ...DEFAULT_FORM },

      dialogCreate: false,
    };
  },
  watch:{
    'pagination.page':{
      immediate:true,
      handler() {
        this.init();
      },
    },
  },
  methods:{
    async init() {
      const params = {
        'sort':'-id',
        'page': this.pagination.page,
        'per-page': 5,
      };
      this.loading = true;
      try {
        const response = await adminNotificationService.get(params);
        this.pagination = getPagination(response.headers);
        this.notifications = response.data.data;
      } catch (error) {
        this.$toast.error(error.response.data.result_message);
      } finally {
        this.loading = false;
      }
    },
    async deleteNotification(id) {
      try {
        await adminNotificationService.delete(id);
        this.init();
      } catch (error) {
        this.$toast.error(error.response.data.result_message);
      }
    },

    async createNotification() {
      try {
        await adminNotificationService.create(this.form);

        this.dialogCreate = false;

        this.init();
      } catch (error) {
        this.$toast.error(error.response.data.result_message);
      }
    },
  },

};
</script>

<style>

</style>
